import React from 'react';
import { authRoles } from 'app/auth';

// Feature: heidi-storage - per-organization shared document store (Phase 1 UI)
export const DocumentsConfig = {
	settings: { layout: { config: {} } },
	// Org members (admins, instructors, users, participants) can reach the
	// page; the backend gates read/write per role and per-document ACL.
	auth: [...authRoles.user, ...authRoles.instructor, ...authRoles.participant],
	routes: [
		{
			// Lives under the Storage section; /documents redirects here.
			path: '/storage/documents',
			component: React.lazy(() => import('./Documents'))
		}
	]
};
